import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

const FieldSkeleton: FC<{ label?: boolean }> = ({ label = true }) => (
  <Box>
    {label && <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />}
    <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
  </Box>
);

export const ProDirectoryFormSkeleton: FC = () => {
  return (
    <Box sx={{ py: 2 }}>
      {/* Step content card */}
      <Box
        sx={{
          p: { xs: 2, sm: 3 },
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Box>
          <Skeleton variant="text" width={220} height={28} />
          <Skeleton variant="text" sx={{ width: { xs: '100%', sm: 320 } }} height={18} />
        </Box>

        {/* Image uploads */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, flexWrap: 'wrap' }}>
          <Skeleton variant="rectangular" width={200} height={200} sx={{ borderRadius: 1, maxWidth: '100%' }} />
          <Skeleton variant="rectangular" width={289} height={200} sx={{ borderRadius: 1, maxWidth: '100%' }} />
        </Box>

        {/* Fields */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
          <FieldSkeleton />
          <FieldSkeleton />
          <FieldSkeleton />
          <FieldSkeleton />
        </Box>
        <Box>
          <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      {/* Footer actions */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 2 }}>
        <Skeleton
          variant="rectangular"
          width={40}
          height={40}
          sx={{ borderRadius: 1.5, display: { xs: 'block', sm: 'none' } }}
        />
        <Skeleton
          variant="rectangular"
          width={130}
          height={40}
          sx={{ borderRadius: 1, display: { xs: 'none', sm: 'block' } }}
        />
        <Skeleton variant="rectangular" width={130} height={40} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  );
};
